export const GET_CUSTOMERS_BY_QUERY_REQUEST = 'GET_CUSTOMERS_BY_QUERY_REQUEST';
export const GET_CUSTOMERS_BY_QUERY_SUCCESS = 'GET_CUSTOMERS_BY_QUERY_SUCCESS';
export const GET_CUSTOMERS_BY_QUERY_FAILURE = 'GET_CUSTOMERS_BY_QUERY_FAILURE';

export const SELECT_CUSTOMER = 'SELECT_CUSTOMER';
export const SELECT_CUSTOMER_BY_DEFAULT_VALUE =
  'SELECT_CUSTOMER_BY_DEFAULT_VALUE';

export const RESET_STATE = 'RESET_STATE';
